<template>
  <div style="background-color:#000">
    <div class="box_one" style="margin-bottom:5px"> 
      <cont-top/>
    </div>   

    <router-view></router-view>

    <div class="box_bottom" > 
      <cont-bottom/>
    </div>
  </div>
</template>


<script>
import ContTop from '../Cont_top'
import ContBottom from '@/views/Components/Cont_bottom'


export default {
  data() {
    return {
      fit : 'contain'
    }
  },
  components : {
    ContTop ,
    ContBottom ,
  }
}

</script>

<style lang="stylus" scoped>
.clear:after {
  display: block;
  clear: both;
  content: '';
}

#container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 0 52px;

}
  
.title {
  position: absolute;
  width: 262px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/brandClassroom/otherClassroom/img1.png');
  background-repeat: no-repeat;
  background-size: contain;
  padding: 40px 43px 39px 46px; 
  box-sizing: border-box;
}

.title_name {
  height: 28px;
  width:  173px;
  background: url('~@/assets/image/brandClassroom/otherClassroom/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}


.line{
  display flex
  border-bottom:1px solid #000
  margin-bottom 5px
}
 .line_item {
   flex : 1
 }

</style>